
import { useState, useEffect } from 'react';
import { IoIosCloseCircleOutline } from "react-icons/io";
import DemoImg from '../../assets/Harsh_Photo.jpeg'; // Assuming this is a placeholder image
import { GiSquirrel } from "react-icons/gi";
interface GoogleCalendarWidgetProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function GoogleCalendarWidget({ open, setOpen }: GoogleCalendarWidgetProps) {
  const embedUrl = import.meta.env.VITE_GOOGLE_CALENDAR_EMBED_URL;
  console.log('Embed URL:', embedUrl);
  const [loading, setLoading] = useState(false);

  // whenever `open` flips to true, start the spinner
  useEffect(() => {
    if (open) {
      setLoading(true);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setLoading(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-transparent backdrop-filter" style={{ backdropFilter: 'brightness(60%) contrast(80%)' }}>
      <div className="relative w-[95vw] max-w-2xl h-[80vh] sm:w-10/12 sm:max-w-4xl sm:h-4/5 bg-white rounded-lg overflow-hidden shadow-lg">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 text-2xl z-50 p-1"
          aria-label="close"
        >
          <IoIosCloseCircleOutline className='mx-auto my-auto size-8'/>
        </button>

        {/* Loader overlay */}
        {loading && (
          <div className="absolute inset-0 bg-white bg-opacity-90 z-40 flex flex-col items-center justify-center text-center rounded-lg">
            <img
              src={DemoImg}
              alt="Loading..."
              className="w-32 h-32 sm:w-40 sm:h-40 mb-4 object-contain mx-auto rounded-full shadow-lg"
            />
            <p className="text-[#06526D] sm:text-lg font-semibold text-primary-main flex flex-col sm:flex-row items-center justify-center px-2 text-center">
              Hold tight! Our AI squirrels are scheduling your demo
              <span className="inline-block">
                <span className="loading-dots ml-1" aria-label="loading">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </span>
              <span
                className="inline-block text-4xl sm:text-5xl animate-squirrel-move mt-2 sm:mt-0 sm:ml-3"
                role="img"
                aria-label="squirrel"
              >
                <GiSquirrel />
              </span>
            </p>
            <style>
            {`
            @keyframes squirrel-move {
              0% {
                transform: translateX(0) scaleX(1);
              }
              49.999% {
                transform: translateX(80px) scaleX(1);
              }
              50% {
                transform: translateX(80px) scaleX(-1) rotate(360deg);
              }
              100% {
                transform: translateX(0) scaleX(-1) rotate(360deg);
              }
            }
            .animate-squirrel-move {
              animation: squirrel-move 2s infinite linear;
            }
            @keyframes blink {
              0%, 80%, 100% { opacity: 0; }
              40% { opacity: 1; }
            }
            .loading-dots span {
              animation: blink 1.4s infinite both;
              font-size: 1.5em;
              line-height: 0;
            }
            .loading-dots span:nth-child(2) {
              animation-delay: 0.2s;
            }
            .loading-dots span:nth-child(3) {
              animation-delay: 0.4s;
            }
            `}
            </style>
          </div>
        )}

        {/* Iframe */}
        <iframe
          src={embedUrl}
          className="w-full h-full border-0"
          title="Booking Calendar"
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
}
